/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Found entity
 */
export type Gsoa_Recommender_Entities = {
    /**
     * Type of entity
     */
    Type?: Gsoa_Recommender_Entities.Type;
    /**
     * Entity identifier
     */
    ID?: string;
    /**
     * Vanr entity
     */
    Vanr?: string;
    /**
     * EAN entity (if more than one EAN is assigned to the entity, then it is selected randomly)
     */
    EAN?: string;
    /**
     * Entity name
     */
    Name?: string;
    /**
     * Last modified date description of entities
     */
    LastChange?: string;
    /**
     * Store availability
     */
    Availability?: string;
};
export namespace Gsoa_Recommender_Entities {
    /**
     * Type of entity
     */
    export enum Type {
        PRODUCT = 'Product',
        CATEGORY = 'Category',
        GENERALIZED_PRODUCT = 'GeneralizedProduct',
        COMMON_BRAND = 'CommonBrand',
    }
}

